export let data = [
{ year: '1951', event: 'ANZUS Pact signed by Australia, New Zealand and USA' },
{ year: '1951', event: 'American post-war occupation of Japan ends' },
{ year: '1952', event: 'George VI dies - Elizabeth II takes British throne' },
{ year: '1952', event: 'Bolivian Revolution' },
{ year: '1952', event: 'Death of Eva Pern ("Evita") in Argentina' },
{ year: '1952', event: 'Huge collectivization push in rural China' },
{ year: '1952', event: 'Samuel Beckett develops Theatre of the Absurd - "Waiting for Godot"' },
{ year: '1952', event: 'Dwight Eisenhower becomes US President' },
{ year: '1953', event: 'New Zealander Sir Edmund Hillary first to reach summit of Everest' },
{ year: '1953', event: 'Death of Sergey Prokofiev (composer)' },
{ year: '1953', event: 'Death of Josef Stalin - Nikita Khruschev becomes Premiere' },
{ year: '1953', event: 'Crick and Watson demonstrate double-helix structure of DNA' },
{ year: '1953', event: 'Soviets successfully test hydrogen bomb' },
{ year: '1953', event: 'Mau Mau Rebellion breaks out in Kenya' },
{ year: '1953', event: 'Korean War ends after involving China, US and several other countries' },
{ year: '1954', event: 'End of First Indochina War - Vietnam partitioned' },
{ year: '1954', event: 'Laos and Cambodia recognized as independent' },
{ year: '1954', event: 'Rock nRoll music becomes popular - Bill Haley, Elvis Presley, etc' },
{ year: '1954', event: 'Anti-Communist McCarthyism censured in US' },
{ year: '1955', event: 'Coup deposes dictator Juan Pern in Argentina' },
{ year: '1955', event: 'Warsaw Pact signed by USSR, Poland, Romania, Hungary, Poland, East Germany, Czechoslovakia and Albania' },
{ year: '1955', event: 'Death of Albert Einstein, German-born physicist' },
{ year: '1956', event: 'Suez Crisis - Britain and France invade Egypt' },
{ year: '1956', event: 'Gamal Abdel Nasser becomes President of Egyptian Republic' },
{ year: '1956', event: 'Hungarian revolt brutally suppressed by Soviets' },
{ year: '1956', event: '"My Fair Lady" popular musical' },
{ year: '1957', event: 'Sir Harold MacMillan becomes British Prime Minister' },
{ year: '1957', event: 'Death of Jean Sibelius (Swedish composer)' },
{ year: '1957', event: 'Russian Sputnik sattelite launched' },
{ year: '1957', event: 'European Economic Comunity (EEC) established' },
{ year: '1957', event: 'Ghana first African colony to gain independence from Britain' },
{ year: '1957', event: 'India claims state of Kashmir' },
{ year: '1958', event: 'Dalai Lama flees Tibet from Chinese persecution' },
{ year: '1958', event: 'Charles de Gaulle given extensive powers in France' },
{ year: '1958', event: 'Ayub Khan becomes military leader of Pakistan' },
{ year: '1958', event: 'Oral contraceptive pill becomes available' },
{ year: '1958', event: 'Great Chinese Famine of 1958-61 kills an estimated 36 million' },
{ year: '1959', event: 'Terrorist organization ETA founded to fight for Basque independence' },
{ year: '1959', event: 'Fidel Castro establishes communist dictatorship in Cuba' },
{ year: '1959', event: 'Communist North Vietnam starts war against Capitalist South' },
{ year: '1960', event: 'Construction of Aswan High Dam in Egypt begins' },
{ year: '1960', event: 'Organization of Petroleum Exporting Countries (OPEC) established' },
{ year: '1960', event: 'DH Lawrence s 1928 book "Lady Chatterleys Lover" legally published in the UK' },
{ year: '1960', event: 'Congo gains independence from Belgium' },
{ year: '1961', event: 'Cuban Missile Crisis after US-backed anti-Castro Bay of Pigs invasion fails' },
{ year: '1961', event: 'Berlin Wall built between East and West Germany' },
{ year: '1961', event: 'Russian Yuri Gagarin becomes first man in space' },
{ year: '1961', event: 'South Africa declares republic and leaves British Commonwealth' },
{ year: '1961', event: 'Portugal loses its territories in Goa, India' },
{ year: '1961', event: 'Death of Ernest Hemingway (writer)' },
{ year: '1962', event: 'Georges Pompidou takes over after vote against Charles de Gaulle' },
{ year: '1962', event: 'Yemenese Civil War' },
{ year: '1962', event: 'Sino-Indian Border Conflict between China and India' },
{ year: '1962', event: 'Death of Marilyn Munroe (actress)' },
{ year: '1962', event: 'Rachael Carsons book "Silent Spring" launches environmental movement' },
{ year: '1963', event: 'The Beatles rise to popularity' },
{ year: '1963', event: 'US President John F Kennedy shot' },
{ year: '1964', event: 'Palestine Liberation Organization (PLO) formed' },
{ year: '1964', event: 'Nelson Mandela jailed for campaigning against apartheid in South Africa' },
{ year: '1964', event: 'Kenya becomes republic under Jomo Kenyatta' },
{ year: '1964', event: 'Indian Prime Minister Jahawarlal Nehru dies' },
{ year: '1964', event: 'Military dictatorship established in Brazil' },
{ year: '1964', event: 'Civil Rights Act passed in US' },
{ year: '1964', event: 'US becomes involved in Vietnam War' },
{ year: '1965', event: 'White government declares independence in Southern Rhodesia' },
{ year: '1965', event: 'Ferdinand Marcos becomes President of Philippines' },
{ year: '1966', event: 'Cultural Revolution begins in China' },
{ year: '1967', event: 'Sir Francis Chichester first to sail around world single-handed' },
{ year: '1967', event: 'Che Guevara, Cuban revolutionary leader, killed in Bolivia' },
{ year: '1967', event: 'First Arab-Israeli (6-Day) War' },
{ year: '1967', event: 'General Agreement on Tarrifs and Trade (GATT) formulated' },
{ year: '1967', event: 'Nigerian Civil War - Biafra famine' },
{ year: '1967', event: 'General Suharto of Indonesia wrests power from President Sukarno' },
{ year: '1967', event: 'First human heart transplant performed in South Africa' },
{ year: '1967', event: '"Flower Power" at its height in California' },
{ year: '1968', event: 'C Day Lewis becomes British Poet Laureate' },
{ year: '1968', event: 'Albania withdraws from Warsaw Pact for ideological reasons' },
{ year: '1968', event: 'Prague Spring uprising in Czechoslovakia crushed by Soviets' },
{ year: '1968', event: 'Pierre Trudeau becomes Prime Minister of Canada' },
{ year: '1968', event: 'Black rights campaigner Martin Luther King assassinated' },
{ year: '1969', event: 'British supersonic aircraft Concorde makes maiden flight' },
{ year: '1969', event: 'Border disputes between China and Russia' },
{ year: '1969', event: 'Provisional IRA, terrorist offshoot of IRA, formed' },
{ year: '1969', event: 'Catholic vs Protestant "Troubles" resume in Ireland' },
{ year: '1969', event: 'Willi Brandt becomes German Chanceller' },
{ year: '1969', event: 'Moammar al-Qaddafi (Gadafi) leads military coup in Libya' },
{ year: '1969', event: 'Neil Armstrong becomes first man to walk on Moon' },
{ year: '1969', event: 'US involvement in Vietnam War peaks' },
{ year: '1970', event: 'Sendero Luminoso ("Shining Path") Maoist guerrilla group founded in Peru' },
{ year: '1971', event: 'Death of Igor Stravinsky (composer)' },
{ year: '1971', event: 'Revolution in Ethiopia overthrows Haile Selassie' },
{ year: '1971', event: 'United Arab Emirates, Bahrain and Qatar become independent from Britain' },
{ year: '1971', event: 'Indira Ghandi becomes Prime Minister of India' },
{ year: '1971', event: 'Indo-Pakistan War - Bangladesh declared independent republic' },
{ year: '1971', event: 'Rapprochement between US and China - Richard Nixons visit' },
{ year: '1971', event: 'Hugo Banzer leads military coup in Bolivia and becomes dictator' },
{ year: '1972', event: '"Bloody Sunday" massacre in Ireland' },
{ year: '1972', event: 'British impose direct rule on Northern Ireland' },
{ year: '1972', event: 'Francis Ford Coppolas movie "The Godfather" released' },
{ year: '1972', event: 'Treaty recognizes East and West Germany as sovereign states' },
{ year: '1972', event: '"Detente" - Strategic Ams Pact between Russia and the West' },
{ year: '1972', event: 'European Free Trade Agreement (EFTA)' },
{ year: '1972', event: 'President Idi Amin expels Asians from Uganda' },
{ year: '1972', event: 'Ceylon becomes independent Republic of Sri Lanka' },
{ year: '1973', event: 'Britain joins European Economic Community' },
{ year: '1973', event: 'General Augusto Pinochet ousts democratic Allende government in Chile' },
{ year: '1973', event: 'Second Arab-Israeli (Yom Kippur) War' },
{ year: '1973', event: 'Saudi Arabia leads huge oil price increases - world economy slows' },
{ year: '1973', event: 'Carl XVI Gustaf becomes King of Sweden' },
{ year: '1973', event: 'Death of Pablo Picasso (Spanish artist)' },
{ year: '1973', event: 'US launches Pioneer II to explore outer planets' },
{ year: '1973', event: 'Henry Kissinger becomes US Secretary of State' },
{ year: '1974', event: 'Alexander Solzhenitsyn deported to the West' },
{ year: '1974', event: 'Turkey intervenes in Cyprus' },
{ year: '1974', event: 'PLO under Yasser Arafat recognized as representing Palestine' },
{ year: '1974', event: 'Portugal overthrows dictatorship - Antnio de Spinola President' },
{ year: '1974', event: 'Portugal grants independence to Mozambique, Angola and other colonies' },
{ year: '1974', event: 'South Africa voted out of UN for apartheid policies' },
{ year: '1974', event: 'India explodes first nuclear device' },
{ year: '1974', event: 'Watergate Scandal - Richard Nixon quits as President' },
{ year: '1975', event: 'Birmingham Pub Bombings by IRA' },
{ year: '1975', event: 'Christian vs Muslim war in Lebanon' },
{ year: '1975', event: 'King Faisal of Saudi Arabia assassinated' },
{ year: '1975', event: 'Juan Carlos becomes King of Spain after Francos death' },
{ year: '1975', event: 'Civil war breaks out in Angola' },
{ year: '1975', event: 'US pulls out of Vietnam War' },
{ year: '1975', event: 'Communists finally triumph in Vietnam, Laos and Cambodia' },
{ year: '1976', event: 'Punk (rebel music cult) develops - Sex Pistols, Clash, etc' },
{ year: '1976', event: 'Death of Sir Benjamin Britten (composer)' },
{ year: '1976', event: 'Mao Tse-Tung dies - Gang of Four arrested' },
{ year: '1976', event: 'Giulio Andreotti leads minority government in Italy' },
{ year: '1976', event: 'Baader-Meinhof Gang (leftist terrorists) active in Germany' },
{ year: '1976', event: 'Free elections re-established in Spain' },
{ year: '1976', event: 'Military coup in Argentina and start of state-sponsored "Dirty War" (until 1983)' },
{ year: '1977', event: 'Israel under Menachem Begin starts West Bank settlements' },
{ year: '1977', event: 'Activist Steve Biko dies in custody in South Africa' },
{ year: '1977', event: 'Zulfikar Ali Bhutto executed after coup in Pakistan' },
{ year: '1978', event: 'Aldo Moro assassinated by leftist Red Brigade terrorists' },
{ year: '1978', event: 'ETA (Basque seperatist group) active in Spain' },
{ year: '1978', event: 'Radical reorganization of Cambodia by cruel Pol-Pot regime' },
{ year: '1978', event: 'Muhammed Zia Ul-Haq becomes hard-line Muslim President of Pakistan' },
{ year: '1979', event: 'Margaret Thatcher becomes British Prime Minister ' },
{ year: '1979', event: 'Military coup in Bolivia' },
{ year: '1979', event: 'Somoza regime in Nicaragua ousted by leftist Sandinistas' },
{ year: '1979', event: 'Soviet invasion of Afghanistan' },
{ year: '1979', event: 'Iranian Revolution - Ayatollah Khomeini proclaims Islamic Republic' },
{ year: '1979', event: 'Camp David Agreement brokers peace between Israel and Egypt' },
{ year: '1979', event: 'Idi Amin forced out of Uganda' },
{ year: '1979', event: '"Boat People" start to flee Communist regime in Vietnam' },
{ year: '1979', event: 'President Park Chung Hee of South Korea assassinated' },
{ year: '1979', event: 'Three Mile Island nuclear reactor incident in US' },
{ year: '1980', event: 'Robert Mugabe leads first black government in Zimbabwe (Rhodesia)' },
{ year: '1980', event: 'John Lennon (singer) shot' },
{ year: '1980', event: 'Social Democratic Party formed' },
{ year: '1980', event: 'Deng Xiao-Ping becomes Chairman of China' },
{ year: '1980', event: 'Relations between East and West Germany deteriorate' },
{ year: '1980', event: 'Military coup in Turkey under Kenan Evren' },
{ year: '1980', event: 'Iran-Iraq War begins' },
{ year: '1980', event: 'Gdansk Shipyard Strike in Poland - Lech Walesa forms Solidarity' },
{ year: '1980', event: 'Tito dies - Yugoslavias six states begin to argue' },
{ year: '1980', event: 'Iranian Hostage Crisis - hostages held in US Embassy in Tehran' },
{ year: '1980', event: 'Eruption of Mount St Helens (60 killed)' },
{ year: '1980', event: 'Ronald Reagan becomes US President' },
{ year: '1981', event: 'Black youths riot in British cities' },
{ year: '1981', event: 'IRA prisoners go on hunger strike - 10 die' },
{ year: '1981', event: 'Franois Mitterrand becomes first Socialist President of France' },
{ year: '1981', event: 'Prince Charles marries Lady Diana Spenser' },
{ year: '1981', event: 'President Anwar al-Sadat of Egypt assassinated by Muslim fundamentalists' },
{ year: '1981', event: 'Greece votes in Socialist Andreas Papandreou' },
{ year: '1981', event: 'AIDS becomes major health threat throughout world' },
{ year: '1982', event: 'Britain regain Falklands Islands (Malvinas) after Argentinian occupation' },
{ year: '1982', event: 'Israel invades Lebanon - Israel-Lebanon War' },
{ year: '1982', event: 'Martial law in Poland ended by Solidarity action' },
{ year: '1983', event: 'Bettino Craxi leads Italian coalition government' },
{ year: '1983', event: 'Helmut Kohl becomes German Chancellor' },
{ year: '1983', event: 'End of Israel-Lebanon War' },
{ year: '1983', event: 'Norways Gro Harlen Brundtland establishes WCE' },
{ year: '1983', event: 'Socialist government headed by Mrio Soares in Portugal' },
{ year: '1983', event: 'Coloureds and Asians allowed vote in South Africa' },
{ year: '1983', event: 'Philippino opposition leader Benigno Aquino assassinated' },
{ year: '1984', event: 'Death of Sir John Betjeman (poet)' },
{ year: '1984', event: 'Miners Strike in Britain' },
{ year: '1984', event: 'Drought and famine in Ethiopia, Eritrea and Sudan' },
{ year: '1984', event: 'Indira Ghandi assassinated by Sikhs - violence erupts in India' },
{ year: '1984', event: 'Bhopal industrial disaster in Madhya Pradesh (4,000 - 25,000 killed)' },
{ year: '1985', event: 'Brazil returns to democratic civilian rule' },
{ year: '1985', event: 'Nevado del Ruiz volcano in Colombia claims 25,000 lives' },
{ year: '1985', event: 'Mikhail Gorbachev becomes Russian Premiere - "Glasnost" and "Perestroika"' },
{ year: '1985', event: 'Enver Hoxha dies - Albania gradually relaxes foreign relations' },
{ year: '1985', event: 'Pro-Solidarity Father Jerzy Popieluzsko assassinated in Poland' },
{ year: '1985', event: 'Tamil separatist resurgence in Sri Lanka' },
{ year: '1986', event: 'Jacques Chirac becomes Prime Minister' },
{ year: '1986', event: 'Chernobyl nuclear power station explodes, contaminating most of Europe' },
{ year: '1986', event: 'Marcos flees country and Corazon Aquino takes power in Philippines' },
{ year: '1987', event: 'Russia and West sign first of several treaties to reduce nuclear arms' },
{ year: '1987', event: 'Iran-Contra Affair - arms for aid scandal' },
{ year: '1987', event: 'Intifada - Palestinian opposition to Israeli occupation of Gaza and West Bank' },
{ year: '1988', event: 'End of Iran-Iraq War' },
{ year: '1988', event: 'US and Canada sign free trade agreement' },
{ year: '1989', event: 'Pro-democracy protest in Tianenmen Square, Beijing, brutally crushed' },
{ year: '1989', event: 'Akihito succedes his father Hirohito  as Emperor of Japan' },
{ year: '1989', event: 'Russians pull out of costly war in Afghanistan' },
{ year: '1989', event: 'European Monetary System (EMS) establishes move towards single currency' },
{ year: '1989', event: 'Death of Salvador Dal (Spanish artist)' },
{ year: '1989', event: 'Exxon Valdez oil-spill in Alaska' },
{ year: '1989', event: 'Overthrow of communist rule in Poland, Hungary, East Germany and Bulgaria' },
{ year: '1989', event: 'Non-violent Velvet Revolution in Czechoslovakia' },
{ year: '1989', event: 'Violent overthrow of Ceausescus communist regime in Romania' },
{ year: '1989', event: 'Berlin Wall demolished' },
{ year: '1990', event: 'Margaret Thatcher resigns - John Major takes over as British PM' },
{ year: '1990', event: 'Alberto Fujimori elected President in Peru' },
{ year: '1990', event: 'East and West Germany unite as Federal Republic of Germany' },
{ year: '1990', event: 'Neslon Mandela released - end of apartheid in South Africa' },
{ year: '1990', event: 'Hubble Space Telescope launched' },
{ year: '1991', event: 'USSR breaks up into constituent countries - end of Soviet era' },
{ year: '1991', event: 'Official dissolution of Warsaw Pact' },
{ year: '1991', event: 'Persian Gulf War starts after Iraq invades Kuwait' },
{ year: '1991', event: 'Ethiopian Civil War ends - Eritrea becomes independent' },
{ year: '1991', event: 'Prime Minister Rajiv Ghandi killed by Tamil suicide bomber' },
{ year: '1992', event: 'Civil war in Bosnia-Herzegovina starts' },
{ year: '1993', event: 'Bill Clinton elected US President' },
{ year: '1993', event: 'New York World Trade Center bombing' },
{ year: '1993', event: 'Salvatore Riina, reputed Mafia leader, arrested' },
{ year: '1993', event: 'European Union (EU) formed by former EEC members' },
{ year: '1993', event: 'Violent constitutional crisis in Russia after Boris Yeltsin dissolves legislature' },
{ year: '1994', event: 'Jean Chrtien becomes Canadian Prime Minister' },
{ year: '1994', event: 'Rwandan genocide of ethnic Tutsis by Hutus' },
{ year: '1994', event: '"Chunnel", rail tunnel between England and France, inaugurated' },
{ year: '1994', event: 'IRA announce unconditional cease-fire - lasts until 1996' },
{ year: '1994', event: 'Construction starts on Chinas Three Gorges Dam' },
{ year: '1994', event: 'North American Free Trade Agreement (NAFTA) established' },
{ year: '1994', event: 'Nelson Mandela becomes first black President of South Africa' },
{ year: '1994', event: 'Sovereignty of Quebec narrowly defeated in referendum' },
{ year: '1995', event: 'The Great Hanshin earthquake hits Kobe, Japan, killing over 6,000' },
{ year: '1995', event: 'World Trade Organization (WTO) established to replace GATT' },
{ year: '1995', event: 'End of war in Bosnia-Herzegovina' },
{ year: '1995', event: 'Russian war in Chechnya (ends in 1996)' },
{ year: '1996', event: 'Prince Charles divorces Princess Diana' },
{ year: '1996', event: 'Israel elects Benjamin Netanyahu as prime minister' },
{ year: '1997', event: 'Tony Blair becomes British Prime Minister' },
{ year: '1997', event: 'Hong Kong returns to Chinese rule' },
{ year: '1997', event: 'US spacecraft begins exploration of Mars' },
{ year: '1997', event: 'Princess Diana killed in Paris car accident' },
{ year: '1997', event: 'Asian financial crisis' },
{ year: '1997', event: 'Catholic nun Mother Teresa dies after nearly 50 years work in India' },
{ year: '1998', event: 'Male impotence drug Viagra licensed for use in USA' },
{ year: '1998', event: 'Good Friday Accord (Belfast Agreement) signed by Ireland and Britain' },
{ year: '1998', event: 'Indonesian dictator Suharto steps down after 32 years in power' },
{ year: '1998', event: 'German chancellor Helmut Kohl defeated by Gerhard Schrder' },
{ year: '1999', event: 'Bill Clinton acquitted in impeachment trial' },
{ year: '1999', event: 'Euro launched on international currency markets' },
{ year: '1999', event: 'King Hussein of Jordan dies after ruling for 46 years' },
{ year: '1999', event: 'Columbine High School murders' },
{ year: '1999', event: 'Nelson Mandela retires as president of South Africa - succeeded by Thabo Mbeki' },
{ year: '1999', event: 'Military coup led by Gen. Pervez Musharraf overthrows Pakistani government' },
{ year: '1999', event: 'China launches first spacecraft' },
]


// WEBPACK FOOTER //
// ./src/data.js